import { render } from "./FormLightingEvaluation.vue?vue&type=template&id=940d9636&scoped=true"
import script from "./FormLightingEvaluation.vue?vue&type=script&lang=js"
export * from "./FormLightingEvaluation.vue?vue&type=script&lang=js"

import "./FormLightingEvaluation.vue?vue&type=style&index=0&id=940d9636&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940d9636"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSelect});
